import axios, {AxiosResponse} from "axios";
import {MarketArea} from "@/model/MarketArea/MarketArea";
import {MarketAreaCategory} from "@/model/MarketArea/MarketAreaCategory";

const PATH = "/inventories";
const PATH_MARKET_AREAS = `${PATH}/market-areas`;
const PATH_MARKET_AREAS_CATEGORIES = `${PATH}/market-area-categories`;

class InventoriesService {
    // region MARKET AREAS
    createMarketArea (payload: MarketArea): Promise<AxiosResponse<MarketArea>> {
        return axios.post(`${PATH_MARKET_AREAS}`, {...payload}, {headers: {"Content-Type": "application/json"}});
    }
    updateMarketArea (payload: MarketArea) {
        return axios.put(`${PATH_MARKET_AREAS}/${payload.id}`, payload);
    }
    deleteMarketArea(marketAreaId: number): Promise<AxiosResponse<null>> {
        return axios.delete(`${PATH_MARKET_AREAS}/${marketAreaId}`);
    }
    // endregion

    // region MARKET AREA CATEGORIES
    createMarketAreaCategory (payload: MarketAreaCategory): Promise<AxiosResponse<MarketAreaCategory>> {
        return axios.post(PATH_MARKET_AREAS_CATEGORIES, payload, {headers: {"Content-Type": "application/json"}});
    }
    updateMarketAreaCategory (payload: MarketAreaCategory) {
        return axios.put(PATH_MARKET_AREAS_CATEGORIES, payload);
    }
    deleteMarketAreaCategory(marketAreaCategoryId: number): Promise<AxiosResponse<null>> {
        return axios.delete(`${PATH_MARKET_AREAS_CATEGORIES}/${marketAreaCategoryId}`);
    }
    // endregion
}

export default new InventoriesService();
